<template id="cast">
	<div class="page page-cast">
		<page-top></page-top>
		<div class="page-content">
			
			<div class="left">
				<div class="heading">STAFF&CAST</div>
				<div class="nav">
					<div class="nav-item"><a>&gt;&nbsp;LIST FOR STAFF</a></div>
					<div class="nav-item"><a>&gt;&nbsp;LIST FOR CAST</a></div>
				</div>
			</div>
			<div class="right">
				
				<div class="staff">
					<div class="heading">STAFF<div class="heading-bg"></div></div>
					<div class="box">
						<div class="box-content">
							<div class="item" v-for="item in staffs">
								<span class="position">{{item.position}}</span><span class="divider">-</span><span class="name">{{item.name}}</span>		
							</div>
						</div>
					</div>
				</div>

				<div class="cast">
					<div class="heading">CAST<div class="heading-bg"></div></div>
					<div class="box">
						<div class="box-content">
							<div class="item" v-for="item in casts">
								<span class="position">{{item.position}}</span><span class="divider">-</span><span class="name">{{item.name}}</span>		
							</div>
						</div>
					</div>
				</div>

				<div class="horizontal-line">
					<div class="bg-left"></div>
					<div class="bg-center"></div>
					<div class="bg-right"></div>
				</div>
				
			</div>
		
		</div>

		<page-bottom></page-bottom>

	</div>
</template>

<script>
export default {
	data: function() {
		return {
			staffs: global.staffs || [],
			casts: global.casts || []
		}
	},
	created() {

		if (!this.staffs.length) {
			this.axios.get('/staff/getList').then((response) => {
				this.staffs = response.data
				global.staffs = response.data
			})
		}
		if (!this.casts.length) {
			this.axios.get('/cast/getList').then((response) => {
				this.casts = response.data
				global.casts = response.data
			})
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/Cast.vue